// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multiselect[data-v-490c262b] .multiselect__tag{background-color:#4d92e3!important}.multiselect[data-v-490c262b] .multiselect__tag-icon:hover{background-color:#2e62a2!important}.multiselect[data-v-490c262b] .multiselect__tag-icon:after{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
